/**
 * @description 导出默认主题配置
 */
export const theme = {
    // 可选配置 布局:default
    // 是否开启 Breadcrumb
    isBreadcrumb: true,
    // 是否开启 Tags-View
    isTagsView: true,
    // 是否固定 Header
    isFixedHead: false,
    // 是否侧边栏 Logo
    isLogo: false,
    // 是否折叠导航菜单
    isCollapse: false,
    // column布局和ce布局下的左侧导航是否缩放60px显示
    isMenuMini: false,
    // 是否只保持一个子菜单的展开
    isUniqueOpened: false,
    // 是否显示登录用户头像
    isUserPhoto: true,
    // 切换布局：1、 classic 经典布局 2、 fashion 时尚布局 3、 elegant 典雅布局 4、 strange 怪异布局
    layoutSet: 'ce',
    // 布局样式 0、default 默认 1、green 绿色 2、glory 橙色 3、ocean 蓝色 4、dark 黑夜模式
    themeSet: 'default',
    // 切换布局时的 loading
    // layoutLoading: false,
    // 切换布局时的 loading 时间
    loadingTimer: 700,
    // 菜单主题颜色 1、 dark 暗色  2、 light 亮色
    subMenuTheme: 'dark',
    // 自动菜单分割(仅 classic 经典布局生效)
    isSplitMenu: false,
    // 灰色模式
    isGrayscale: false,
    // 色弱模式
    isInvert: false,
    // 开启水印
    isWartermark: false,
    // 水印文案
    wartermarkText: 'ceshi@300.cn',
    // 默认主页面切换动画，可选 1、 slide-right 2、 slide-left 3、 opacitys
    animation: 'slide-left',
};
